import { render, staticRenderFns } from "./ReportePiezasTerminadas.vue?vue&type=template&id=b4236f3a&"
import script from "./ReportePiezasTerminadas.vue?vue&type=script&lang=js&"
export * from "./ReportePiezasTerminadas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports